import React, { useEffect, useState } from "react";
import "./CircleTable.css";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import apiUrl from "../../utils/ApiConfig";

export default function CircleTable() {
  const [resobj, setResObj] = useState("");
  const [resobj2, setResObj2] = useState([]);
  const [flag, setFlag] = useState(false);

  useEffect(() => {
    async function myApp() {
      const response = await fetch(
        `${apiUrl}/api/Dayerehs`,
        {
          method: "GET",
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setResObj(Object.entries(data));
          Object.entries(data);
          setFlag(true);
        });
    }
    myApp();

    // setTimeout(() => {
    //    setFlag(prev=>!prev)
    // }, 2000);
  }, []);
  //////////////////
  useEffect(() => {
    if (resobj.length != 0) {
      resobj.forEach((item) => {
        let obj = {
          id: item[1].ID,
          name: item[1].Name,
          LastModified: item[1].LastModified,
          Order: item[1].Order,
          IsVisible: item[1].IsVisible,
        };
        setResObj2((prev) => [...prev, obj]);
      });
    }
  }, [flag]);

  const rows = resobj2;
  const columns = [
    { field: "id", headerName: "ID", width: 90 },

    {
      field: "IsVisible",
      headerName: "قابل مشاهده ",
      width: 150,
      editable: true,
    },
    ///////////////////////////////
    {
      field: "Order",
      headerName: "شکل دایره",
      width: 150,

      renderCell: (params) => {
        return (
          <div>
            <div className="addcirgetapi-tableimg-div">
              {params.row.Order.split(",").map((src) => (
                <div className="xxxx">
                  <img className="addcirgetapi-tableimg-img" src={src} alt="" />
                </div>
              ))}
            </div>
          </div>
        );
      },
    },

    ////////////////////////////
    {
      field: "name",
      headerName: "نام دایره",
      width: 150,
      editable: true,
    },

    {
      field: "LastModified",
      headerName: "آخرین تغییر",
      width: 200,
      editable: true,
    },
  ];
  return (
    <>
      {flag && (
        <div className="circletable-box-div">
          <Box sx={{ height: 400, width: "100%" }} className="circletable-box ">
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              checkboxSelection
              disableRowSelectionOnClick
            />
          </Box>
        </div>
      )}
    </>
  );
}
